import React from "react";
import { LoginError } from "../../../models/enumerations/login-error";
import { Button } from "../../button/button";
import { useTranslation } from 'react-i18next';

export interface LoginModalButtonsProps {
    error: LoginError,
    onFirstButtonClick: Function,
    onSecondButtonClick: Function,
}

const COMPONENT_CLASS = 'c-login-modal';

/**
 * Represents buttons on the login modal.
 * 
 * @param props The properties
 * @returns {JSX.Element} The component
 */
const LoginModalButtons: React.FC<LoginModalButtonsProps> = (props) => {
    const {
        error,
        onFirstButtonClick,
        // onSecondButtonClick,
    } = props;
    const { t } = useTranslation();

    const handleButtonClick = () => {
        onFirstButtonClick();
    };

    // const handleSecondButtonClick = () => {
    //     onSecondButtonClick();
    // };

    let areaClass = `${COMPONENT_CLASS}__button-area -no-lower-message`;
    let buttonText = t('buttons.btn_confirm');

    if (error === LoginError.AdminDeactivatedBilling) {
        buttonText = t('buttons.btn_reactivateAcc');
    }

    if (error === LoginError.AdminDeactivated) {
        buttonText = t('buttons.btn_reactivateReq');
    }

    if (error === LoginError.AdminTrialExpired) {
        // buttonText = 'Upgrade Now';
        buttonText = t('buttons.btn_upgradeReq');
    }

    if (error === LoginError.SubscriptionPaymentFailed) {
        buttonText = t('buttons.btn_reactivateAcc');
    }

    return (
        <div className={areaClass}>
            <Button
                buttonStyle="primary"
                buttonText={buttonText}
                onClick={handleButtonClick}
            />
            {/* {
                error === LoginError.AdminTrialExpired && (
                    <>
                        <h2 style={{ margin: '15px 50px 15px 50px' }}>Or</h2>
                        <a
                            href="mailto:support@symmio.com"
                            className={`${COMPONENT_CLASS}__button -second-button`}
                            onClick={handleSecondButtonClick}
                        >
                            Contact Us
                        </a>
                    </>
                )
            } */}
        </div >
    );
};

export default LoginModalButtons;